import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface DashboardGuardProps {
  children: ReactNode;
}

const DashboardGuard: React.FC<DashboardGuardProps> = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const accountType = localStorage.getItem('accountType');

    if(!accountType) {
        navigate('/login');
        return;
    }

    // specify the routes based on account type
    const allowedRoutes = accountType === 'partner' ? ['/partners'] : accountType === 'operations' ? ['/operations'] : [];

    // check if the current route is allowed
    const currentPath = window.location.pathname;
    const isRouteAllowed = allowedRoutes.some(route => currentPath.startsWith(route));

    // redirect if the current route is not allowed
    if (!isRouteAllowed) {
      navigate(`/${accountType}/transactions`);
    } else {
        return
    }

  }, [navigate]);

  return <>{children}</>;
};

export default DashboardGuard;
